var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "notification-list" }, [
    _vm.notifications.length === 0 && _vm.isLoadComplete
      ? _c("div", { staticClass: "empty-message" }, [
          _vm._v(_vm._s(_vm.$t("inboxPage.noMessages"))),
        ])
      : _vm._e(),
    _vm.notifications.length > 0
      ? _c(
          "div",
          { staticClass: "list-container" },
          [
            _vm.notificationType === "agent"
              ? _vm._l(_vm.notifications, function (notification) {
                  return _c(
                    "div",
                    {
                      key: `agent-${_vm.getNotificationKey(notification)}`,
                      staticClass: "notification-item",
                    },
                    [
                      _vm.isInitiallyUnread(notification)
                        ? _c("span", { staticClass: "unread-dot" })
                        : _vm._e(),
                      _c("div", { staticClass: "notification-body" }, [
                        _c("div", { staticClass: "notification-meta" }, [
                          _c("span", { staticClass: "notification-date" }, [
                            _vm._v(_vm._s(_vm.formatDate(notification))),
                          ]),
                          _c("span", { staticClass: "notification-category" }, [
                            _vm._v(_vm._s(_vm.getCategoryLabel(notification))),
                          ]),
                        ]),
                        _c("div", { staticClass: "notification-content" }, [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.getAgentMessage(notification)
                              ),
                            },
                          }),
                        ]),
                      ]),
                    ]
                  )
                })
              : _vm._l(_vm.notifications, function (notification) {
                  return _c(
                    "div",
                    {
                      key: `nolaNovel-${_vm.getNotificationKey(notification)}`,
                      staticClass: "notification-item clickable",
                      on: {
                        click: function ($event) {
                          return _vm.handleNolaNovelClick(notification)
                        },
                      },
                    },
                    [
                      _vm.isInitiallyUnread(notification)
                        ? _c("span", { staticClass: "unread-dot" })
                        : _vm._e(),
                      _c("div", { staticClass: "notification-body" }, [
                        _c("div", { staticClass: "notification-meta" }, [
                          _c("span", { staticClass: "notification-date" }, [
                            _vm._v(_vm._s(_vm.formatDate(notification))),
                          ]),
                          _c("span", { staticClass: "notification-category" }, [
                            _vm._v(_vm._s(_vm.getCategoryLabel(notification))),
                          ]),
                        ]),
                        _c("div", { staticClass: "notification-content" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.getNolaNovelTitle(notification)) +
                              " "
                          ),
                        ]),
                      ]),
                      _c("span", { staticClass: "arrow-right" }),
                    ]
                  )
                }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }